// import '@webcomponents/custom-elements';
// import 'core-js/es/array';
// import 'core-js/es/object';
// import 'core-js/es/promise';
// import 'core-js/es/reflect';
// import 'core-js/es/symbol';
// import "core-js/web/immediate";

// minimal setImmediate polyfill

// type Callback = () => unknown;

if (!window.setImmediate) {
	// @ts-ignore
	window.setImmediate = window.setTimeout;
/*

	window.setImmediate = (() => {
		const { port1, port2 } = new MessageChannel();
		const q: Callback[] = [];

		port1.onmessage = () => {
			q.shift()();
		};

		return (f: Callback) => {
			port2.postMessage(null);
			q.push(f);
			// return setTimeout(() => {});
		};
	})();
	/*
	window.clearImmediate = (id) => {
		clearTimeout(id);
	};
	*/
}
